import React from 'react'
import { useTranslation } from 'react-i18next'
import InputField from '../../../../../component/formFields/InputField'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditVideoSection = ({ formHandler, providerInfo ,isLoading}) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("video")} 
            icon="mdi:video"
            className="edit-video"
        >
            <div className="edit-form-grid">
                <InputField 
                    formHandler={formHandler} 
                    name={"videoUrl"} 
                    isLoading={isLoading}
                    type="url"
                    defaultValue={providerInfo?.videoUrl}
                    isRequired={false}
                />
                <p className="helper-text">{t("video-url-hint")}</p>
            </div>
        </SectionCard>
    )
}

export default EditVideoSection

